import ResourceEditTabBase from "./ResourceEditTabBase.jsx";
import { HasTaskHistoryBaseMixin } from "../../widget/mixins/HasTaskHistoryBaseMixin.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { pluralize } from "../../../other/utils/otherUtils.jsx";

export default class ResourceTaskHistoryTab extends HasTaskHistoryBaseMixin(
  ResourceEditTabBase
) {
  static get $name() {
    return "ResourceTaskHistoryTab";
  }

  static get type() {
    return "resourcetaskhistorytabV2";
  }

  get swivuDeepLinkSlug() {
    return "history";
  }

  static get configurable() {
    return {
      tab : {
        icon: "fa-regular fa-clock w-4 h-4"
      },
      items: {
        taskHistoryGrid: {
          stateId: PERSISTENCE_STATE_KEYS.resourceHistoryGrid
        }
      }
    };
  }

  loadRecord(record, context) {
    super.loadRecord(record, context);

    const { taskHistoryGrid } = this.widgetMap;
    if (record.events) {
      taskHistoryGrid.data = record.events.map(
        ({ name, task, startDate, endDate, duration, durationUnit }) => {
          return {
            task,
            name,
            startDate,
            duration: `${duration || ""} ${pluralize(duration, durationUnit) || ""}`,
            endDate,
            status: task?.statusValue,
            color: task?.color,
            taskStyle: task?.taskStyle,
          };
        }
      );
    } else {
      taskHistoryGrid.data = [];
    }
  }
}

ResourceTaskHistoryTab.initClass();
